import React from 'react'
import styled from 'styled-components'
import FacebookShareButton from 'react-share/lib/FacebookShareButton'
import TwitterShareButton from 'react-share/lib/TwitterShareButton'
import TwitterIcon from 'react-share/lib/TwitterIcon'
import FacebookIcon from 'react-share/lib/FacebookIcon'
import WhatsappShareButton from 'react-share/lib/WhatsappShareButton'
import WhatsappIcon from 'react-share/lib/WhatsappIcon'
import EmailShareButton from 'react-share/lib/EmailShareButton'
import EmailIcon from 'react-share/lib/EmailIcon'
import RedditShareButton from 'react-share/lib/RedditShareButton'
import RedditIcon from 'react-share/lib/RedditIcon'

const StyledSocialMediaShareButtons = styled.div`
  margin-top: 1.4rem;
  > * {
    margin-right: 1rem;
    outline: none;
  }
`

interface ISocialMediaShareButtonsProps {
  url: string
  size?: number
  title: string
}

const SocialMediaShareButtons: React.FC<ISocialMediaShareButtonsProps> = ({
  url,
  size = 40,
  title,
}) => {
  const subject = `${title} #education #teacher #college #school #australia #melbourne #sydney #brisbane #perth #adelaide #nsw #vic #qld #wa`
  return (
    <StyledSocialMediaShareButtons>
      <FacebookShareButton url={url} quote={subject}>
        <FacebookIcon size={size} round />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={subject}>
        <TwitterIcon size={size} round />
      </TwitterShareButton>
      <WhatsappShareButton url={url} title={subject}>
        <WhatsappIcon size={size} round />
      </WhatsappShareButton>
      <RedditShareButton
        url={url}
        title={subject}
        windowWidth={660}
        windowHeight={460}
        className="Demo__some-network__share-button"
      >
        <RedditIcon size={size} round />
      </RedditShareButton>
      <EmailShareButton url={url} subject={subject}>
        <EmailIcon size={size} round />
      </EmailShareButton>
    </StyledSocialMediaShareButtons>
  )
}

export { SocialMediaShareButtons }
